import { CheckIcon, AlertIcon, XIcon } from './Icons';

const TYPE_STYLES = {
  success: 'border-emerald-500/30 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-800 dark:text-emerald-200',
  error: 'border-red-500/30 bg-red-50 dark:bg-red-900/20 text-red-800 dark:text-red-200',
  info: 'border-brand-500/30 bg-brand-50 dark:bg-brand-900/20 text-brand-800 dark:text-brand-200',
};

const TYPE_ICONS = {
  success: <CheckIcon />,
  error: <AlertIcon />,
  info: <AlertIcon />,
};

export default function Toast({ toast, onDismiss }) {
  const styles = TYPE_STYLES[toast.type] || TYPE_STYLES.info;
  return (
    <div
      role="status"
      className={`flex items-start gap-3 rounded-lg border px-4 py-3 shadow-soft animate-slide-up max-w-sm ${styles}`}
    >
      <span className="mt-0.5 shrink-0">{TYPE_ICONS[toast.type] || TYPE_ICONS.info}</span>
      <div className="flex-1">
        {toast.title && <p className="text-sm font-semibold">{toast.title}</p>}
        {toast.message && <p className="text-sm opacity-90">{toast.message}</p>}
      </div>
      <button
        onClick={() => onDismiss(toast.id)}
        aria-label="Dismiss notification"
        className="text-current opacity-70 hover:opacity-100"
      >
        <XIcon width={14} height={14} />
      </button>
    </div>
  );
}
